import {FC, PropsWithChildren} from 'external/react'

import ButtonBackContainer from './ButtonBackContainer'

const PaymentContainer: FC<PropsWithChildren> = props => {
    const {children} = props
    return (<ButtonBackContainer iconName='faHandHoldingDollar' label='Pagos'>{children}</ButtonBackContainer>)
}

export {PaymentContainer as default}